import Vue from 'vue';
import VueGtag, { event } from 'vue-gtag';
import linkify from 'linkifyjs/element';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import api from './api';
import './filters';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.prototype.$api = api;

Vue.use(VueGtag, {
    config: { id: 'G-Y2LXXQ1XRN' }
}, router);

Vue.use(VueTheMask);

Vue.directive('track', (el, binding) => {
    el.onclick = () => {
        if ('A' === el.tagName && el.href) {
            event(binding.value?.action || 'click', { event_category: binding.value?.category || 'Link', event_label: binding.value?.label || el.href, value: binding.value?.value });
        } else if (binding.value?.category && binding.value?.action && binding.value?.label) {
            event(binding.value?.action, { event_category: binding.value?.category, event_label: binding.value?.label, value: binding.value?.value });
        }
    };
});

Vue.directive('linkify', (el, binding) => {
    linkify(
        el,
        Object.assign(
            {
                className: null,
                events: {
                    click(e) {
                        event(binding.value?.action || 'click', { event_category: binding.value?.category || 'Link', event_label: binding.value?.label || e.target.href, value: binding.value?.value });
                    }
                }
            },
            binding.value || {}
        )
    );
});

async function init() {
    try {
        await store.dispatch('init');
    } catch (err) {
        // do nothing
    }

    new Vue({
        router,
        store,
        vuetify,
        render: (h) => h(App)
    }).$mount('#app');
}
init().then(() => {});
